import { SnPoint } from '@lib/geo/helpers';

export function toGoogleMapPoint(point: SnPoint): google.maps.Point {
  return new google.maps.Point(point.x, point.y);
}

export function fromGoogleMapPoint(point: google.maps.Point): SnPoint {
  return new SnPoint(point.x, point.y);
}

export function convertPolygonToCoordinates(polygon: google.maps.Polygon): number[][][] {
  return polygon
    .getPaths()
    .getArray()
    .map((path) =>
      path
        .getArray()
        .map(({ lat, lng }) => [lng(), lat()])
        .concat([[path.getAt(0).lng(), path.getAt(0).lat()]]),
    );
}
